export default __webpack_public_path__ + "static/media/scholoarship2018.df7ff055.jpg";